module.exports = __webpack_public_path__ + "img/eyebrow_female_straight_thick.65707f4a.png";